<template>

  <div class="mb-3">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span class="medium-text">{{ operationCharge.name }}</span>
        <trash-icon v-if="(operationCharge.id&&!operationCharge.bankCredit)||operationCharge.hasOwnProperty('status')"
                    class="main-red-color trashIcon ml-2"
                    size="16"
                    @click="removeOperationCharge"/>
      </div>
    </div>

    <div class="row mt-2">

      <div class="col-md-4">
        <b-input-group>
          <b-form-input
              id="prixTTC-input"
              v-model="operationCharge.prixTTC"
              v-disable-scroll
              :disabled="disabledInput(operationCharge)"
              :placeholder="$t(`operationCharge.Prix${this.isHT && !disabledInput(operationCharge) ? 'HT':'TTC'}`)"
              min="0"
              step="any"
              type="number"
              @input="handlePrixTTCInput"
              @change="emitChangeValue">
          </b-form-input>
          <b-input-group-append>{{ $t(`euros.prix${this.isHT && !disabledInput(operationCharge) ? 'HT':'TTC'}`) }}</b-input-group-append>
        </b-input-group>
        <!-- Indicateur de modification manuelle pour les charges en pourcentage -->
        <div v-if="isPercentageModeCharge(operationCharge) && operationCharge.manuallyEdited" class="mt-1">
          <small class="text-primary">
            <i class="fas fa-exclamation-triangle"></i>
            {{ $t('operationCharge.convertToStatic') }}
          </small>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

export default {

  name: "OperationChargeComponent",

  components: {},

  props: {
    operationCharge: {
      type: Object,
      default: null
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  emits: ['removedOperationCharge', 'didChangeValue'],

  data() {
    return {
      originalPrixTTC: null
    }
  },

  mounted() {
    if (this.isPercentageModeCharge(this.operationCharge)) {
      this.originalPrixTTC = this.operationCharge.prixTTC
    }
  },

  methods: {

    removeOperationCharge() {
      this.$emit('removedOperationCharge', this.operationCharge)
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    handlePrixTTCInput() {
      if (this.isPercentageModeCharge(this.operationCharge)) {
        const currentValue = parseFloat(this.operationCharge.prixTTC) || 0
        const originalValue = parseFloat(this.originalPrixTTC) || 0
        if (Math.abs(currentValue - originalValue) > 0.01) {
          this.$set(this.operationCharge, 'manuallyEdited', true)
        } else {
          this.$set(this.operationCharge, 'manuallyEdited', false)
        }
      }
    },

    isPercentageModeCharge(operationCharge) {
      return operationCharge && (
        operationCharge.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' ||
        operationCharge.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX' ||
        operationCharge.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_PRIX_REVIENT' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_COUT_TRAVAUX' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE'
      )
    },

    disabledInput(operationCharge) {
      if (operationCharge.hasOwnProperty('status')) {
        return false
      } else if (operationCharge.bankCredit || operationCharge.typeFrais.value === "INTERET_EMPRUNT") {
        return true
      }
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/OperationChargeComponent.vue